import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import store from '@/store'
import { ISimpleUploaderFile } from '@/components/SimpleUploader/type'

export interface ISimpleUploaderState {
  uploadFileList: ISimpleUploaderFile[] // 上传的文件列表
  isFileUploading: boolean // 当前是否有正在上传的任务，退出登录或者关闭标签页时需要弹窗提示用户
  alertDialogVisible: boolean // 弹窗显示状态
}

@Module({ dynamic: true, store, name: 'simple-uploader' })
class SimpleUploader extends VuexModule implements ISimpleUploaderState {
  public uploadFileList: ISimpleUploaderFile[] = []
  public isFileUploading = false
  public alertDialogVisible = false

  @Mutation
  private TOGGLE_ALERT_DIALOG_VISIBLE(alertDialogVisible: boolean) {
    this.alertDialogVisible = alertDialogVisible
  }
  @Mutation
  private TOGGLE_FILE_UPLOADING(isFileUploading: boolean) {
    this.isFileUploading = isFileUploading
  }
  @Mutation
  private SET_UPLOAD_FILE_LIST(uploadFileList: ISimpleUploaderFile[]) {
    this.uploadFileList = uploadFileList
  }

  @Action
  public ToggleAlertDialogVisible(alertDialogVisible: boolean) {
    this.TOGGLE_ALERT_DIALOG_VISIBLE(alertDialogVisible)
  }
  @Action
  public ToggleFileUploading(isFileUploading: boolean) {
    this.TOGGLE_FILE_UPLOADING(isFileUploading)
  }
  @Action
  public SetUploadFileList(uploadFileList: ISimpleUploaderFile[]) {
    const isFileUploading = !!uploadFileList.find(file => {
      const { completed, aborted, paused, error } = file
      return !completed && !aborted && !paused && !error
    })
    this.TOGGLE_FILE_UPLOADING(isFileUploading)
    this.SET_UPLOAD_FILE_LIST(uploadFileList)
  }
}

export const SimpleUploaderModule = getModule(SimpleUploader)
